import SEO from "../components/common/SEO";
import PillButton from "../components/common/PillButton";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <SEO title="Page Not Found" />
      <div className="font-heading text-8xl font-bold text-sky-400/30">404</div>
      <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-white">Page not found</h1>
      <p className="mt-3 max-w-md text-slate-400">The page you're looking for doesn't exist or has moved.</p>
      <div className="mt-8">
        <PillButton to="/">Back to Home</PillButton>
      </div>
    </div>
  );
}
